import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PlusOutlinedSvg from "@ant-design/icons-svg/es/asn/PlusOutlined";
import AntdIcon from "../components/AntdIcon";
var PlusOutlined = function PlusOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PlusOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(PlusOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'PlusOutlined';
}
export default RefIcon;